
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import InputBlock from '@/common/components/redesigned/InputBlock.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import Constants from '@/common/constants';

  import {
    KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME,
    KEY_COUNTRY_INDICATOR_VES_GETTERS_NAME,
  } from '../../store/keyCountryIndicator/name';
  import { TKeyCountryIndicator, TKeyCountryIndicatorSave } from '../../types/keyCountryIndicator';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  const TEXT_NUMS = {
    1: 'first',
    2: 'second',
    3: 'third',
    4: 'fourth',
    5: 'fifth',
  };

  export default defineComponent({
    name: 'KeyCountryIndicatorForm',
    components: {
      SelectSingleComponentCheckbox,
      ComponentInput,
      ButtonComponent,
      InputBlock,
    },
    emits: ['save'],
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      item: {
        type: Object as PropType<TKeyCountryIndicator>,
        default: () => ({}),
      },
    },
    data(): { localItem: Partial<TKeyCountryIndicator> } {
      return {
        localItem: {},
      };
    },
    created() {
      this.getPartnerCountrySearchId();
      this.getRegionsSearchId();
      this.getIndicators();
    },
    setup: () => ({ v$: useVuelidate() }),
    computed: {
      ...mapGetters({
        partnerCountryList: DIRECTIVES_GETTERS_NAME.getPartnerCountrySearchIdList,
        regionsList: DIRECTIVES_GETTERS_NAME.getRegionsSearchIdList,
        indicatorsList: KEY_COUNTRY_INDICATOR_VES_GETTERS_NAME.getIndicators,
      }),
    },
    methods: {
      ...mapActions({
        getPartnerCountrySearchId: DIRECTIVES_ACTIONS_NAME.getPartnerCountrySearchId,
        getRegionsSearchId: DIRECTIVES_ACTIONS_NAME.getRegionsSearchId,
        getIndicators: KEY_COUNTRY_INDICATOR_VES_ACTIONS_NAME.getIndicators,
      }),
      save() {
        this.v$.$touch();

        if (this.v$.$invalid) {
          return;
        }

        const savePayload: TKeyCountryIndicatorSave = {
          item: this.localItem as TKeyCountryIndicator,
          onSuccess: () => {
            this.$router.push({ name: 'KeyCountryIndicator' });
            Constants.alert.fire('Сохранение ключевого показателя', `Ключевой показатель успешно сохранен`, 'success');
          },
          onError: () => {
            Constants.alert.fire('Сохранение ключевого показателя', Constants.commonError, 'error');
          },
        };

        this.$emit('save', savePayload);
      },
      close() {
        this.$router.push({ name: 'KeyCountryIndicator' });
      },
      getSubjectRfTitle(position: number) {
        return `Субъект РФ №${position}`;
      },
      getBaseSubjectRfKey(position: keyof typeof TEXT_NUMS) {
        return `${TEXT_NUMS[position]}SubjectRf`;
      },
      getSubjectRfKey(position: keyof typeof TEXT_NUMS) {
        return `${this.getBaseSubjectRfKey(position)}Id`;
      },
      getSubjectRfValueKey(position: keyof typeof TEXT_NUMS) {
        return `${this.getBaseSubjectRfKey(position)}Value`;
      },
    },
    validations() {
      return {
        localItem: {
          countryId: { required },
          year: { required },
          indicatorId: { required },
          firstSubjectRfId: { required },
          firstSubjectRfValue: { required },
          secondSubjectRfId: { required },
          secondSubjectRfValue: { required },
          thirdSubjectRfId: { required },
          thirdSubjectRfValue: { required },
          fourthSubjectRfId: { required },
          fourthSubjectRfValue: { required },
          fifthSubjectRfId: { required },
          fifthSubjectRfValue: { required },
        },
      };
    },
    watch: {
      item: {
        handler(newVal) {
          this.localItem = newVal;
        },
        deep: true,
      },
    },
  });
